import StateMachineImported from '@/states/GameStateMachine'
import SignalsImported from '@/signals/GameSignals'
import UIManagerImported from '@/managers/ui/UIManager'
import UIApplicationLoaderImported from '@baseUI/component/loader/UIApplicationLoader'

import AdapterImported from '../Relax/platforms/adapters/AdapterForSlots'
//import AdapterImported from '@Relax/platforms/adapters/AdapterForSlots'
import IntegrationManagerImported from "../Relax/platforms/IntegrationManager";
//import EventManagerImported from "@/UI/managers/UIGameEventManagerFJ"
import RequestsImported from '@/managers/comunication/gamingcorps/GCRequests'
//import UIApplicationImported from '@/UI/application/UIBaseApplicationFJ'
//import UIModelImported from '@/UI/model/UIModelFJ'
//import UIMainContainerImported from '@/UI/containers/UIBaseMainContainerFJ'
//import ConfigDynamicTextStylesImported from "@/UI/config/ConfigDynamicTextStyles";

import SymbolsContainerImported from '@/containers/GameBaseSymbolsContainer'
//import SymbolsContainerImported from '@/containers/GameSymbolsContainer'

import SymbolImported from  "@base/symbols/MultiplierAnimationSymbol";

const GameStateMachine = StateMachineImported
const Signals = SignalsImported
const UIManager = UIManagerImported
const Adapter = AdapterImported
//const EventManager = EventManagerImported
const IntegrationManager = IntegrationManagerImported
const Requests = RequestsImported
//const UIApplication = UIApplicationImported
//const UIModel = UIModelImported
//const UIApplicationLoader = UIApplicationLoaderImported
//const UIMainContainer = UIMainContainerImported
//const ConfigDynamicTextStyles =ConfigDynamicTextStylesImported
const SymbolsContainer = SymbolsContainerImported
const Symbol = SymbolImported

//export {UIApplicationLoader, GameStateMachine, Signals, UIManager, Adapter, IntegrationManager, Requests,
// n, UIModel, UIMainContainer, ConfigDynamicTextStyles, SymbolsContainer, Symbol}
export { GameStateMachine, Signals, UIManager, Adapter, IntegrationManager, Requests, SymbolsContainer, Symbol}
